export const INITIAL_VALUES = {
	country_code: '+966',
	phone: '',
	password: ''
};

export const validate = (t) => (values) => {
	let errors = {};

	if (!values.phone) {
		errors.phone = t('login.validation.phone_required');
	}

	if (!values.password) {
		errors.password = t('login.validation.password_required');
	}
	return errors;
};
